import React from 'react'
import styled from 'styled-components'
import { Redirect } from 'react-router-dom'
import { withApollo } from 'react-apollo'
import { Layout, Menu, Icon, message, Spin, Avatar, Button, Typography, Row, Col, Modal, Select, Form, Tooltip, Input } from 'antd'
import { ErrorMessageFormAPI } from '../../../utils/checkError'
import BeforeLoginForm from '../../../components/user/BeforeLogin'
import LoginForm from '../../../components/user/LoginForm'
import { 
         setToken, 
         isLoggedIn, 
         getLsId, 
         getIsTrial, 
         getOrganization, 
         removeItemSession, 
         appVersion, 
         versionWeb, 
         clearAllStorage 
      } 
from '../../../utils/auth'
import { Mutations, Queries } from '../../../graphql'
import { v4 as uuidv4 } from 'uuid';
import * as crypto from 'crypto'
import { apiKeyNews } from '../../../utils/apiKey'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import MessageSvg from '../../../assets/images/icons/comment.svg';
import FooterLogin from '../../../components/user/FooterLogin'
import iconsQrcode from '../../../assets/images/icons/qr-code.png'
import iconsLine from '../../../assets/images/icons/line-news.png'
import { sendToeventLog } from '../../../utils/eventLog'
import { appendFormData } from '../../../utils/abstainTime'
import { checkLinkURL, passwordEncrypt, userNameEncrypt } from "../../../utils/auth";
import axiosAPI, { urlAttachFile } from "../../../config/axiosAPI";
import ForgetPassword from "../ForgetPassword"
const { Text, Title } = Typography

const BackgroundDiv = styled.div`
	// height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
`

const FormDiv = styled.div`
	padding: 50px 100px;
	box-shadow: 30px 40px 40px 1px rgba(0, 0, 0, 0.15), 0 0px 0px rgba(0, 0, 0, 0.25);
	border-radius 20px;
	background-color: #fff;
	
`
const { confirm } = Modal;

class Login extends React.PureComponent {
	state = {
		check: "login",
		// check: "verify",
		checkVerifyPassword: null,
		visibleCheckusername: false,
		username: "",
		checkCaptcha: false,
		valueRecaptCha: '',
		//////////////////////addmodalINTERNAL_SERVER_ERROR
		showModalErrors: false,
		showCaptcha: false,
		organization: getOrganization(),
		showModalVersion: null,
		showModalCheck:false,
		modalRead:false,
		modalLine: false,
      loadingFullPage: false,
      showTextModal: "",
      btnTextModal: "",
      showFooter: true,
      showModalErrorNameEng: false
		// organization: null,
	}

   	fetchProfile = async () => {
		try {
			const { client } = this.props
			const { data } = await client.query({
				query: Queries.fetchProfile
			})
			return data
		} catch (e) {
			// message.error('Something went wrong. Please try again', e)
		}
	}

	onSubmit = async (password, remember) => {
     
		try {
         this.setState({
            loadingFullPage: true
         })
			const { client } = this.props
			const API_DEVICE_KEY = atob(apiKeyNews())
			const { data, errors } = await client.mutate({
				mutation: Mutations.login,
				variables: {
					lsid: getLsId(),
					password: password.password,
					appVersion: appVersion(),
					apiKey: API_DEVICE_KEY,
					organization: getOrganization(),
					ssoId: this.state.username
				}
			})

         console.log("datatest", data)

			this.setState({
				loadingFullPage: true
			})

			////////////////////addmodalINTERNAL_SERVER_ERROR
			if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
				await this.setState({
					showModalErrors: true
				})
			}
			if (data) {
            userNameEncrypt(this.state.username)
            passwordEncrypt(password.password)
            localStorage.setItem('expiredDate', data.login.notiChangePwdFlag)
				setToken(data.login, '1')
            localStorage.setItem('sessionID', data.login.sessionID)
            localStorage.setItem('appUsername', data.login.appUsername)
				// removeItemSession('lsid')
				// removeItemSession('organization')
				removeItemSession('reCaptchaCheck')
            const profile = await this.fetchProfile()
            console.log("fetchProfile", profile.fetchProfile)
            localStorage.setItem('IsTrial', profile.fetchProfile.isTrial)
				let userId = null;
				let param = profile.fetchProfile.employeeCodes[0];
				let sourceDb = profile.fetchProfile.currentProfile.split(':')[1];
				let path = '/login';
				let action = 'ClickButton';

				sendToeventLog(userId, param, sourceDb, path, action);

            if(profile.fetchProfile.isTrial){
               window.location.href = '/course'
            }else{
               window.location.href = '/news'
            }
				
            // await this.setState({
            //    loadingFullPage: false
            // })
				// window.location.href = '/profile/list'
			}else{
				this.setState({
				loadingFullPage: false
				})
         }

		} catch (error) {
			this.setState({
				loadingFullPage: false
			 })
			// console.log('error',error)
			// message.error("รหัสบุคลากรไม่ถูกต้อง")
			// const errorMessage = error.graphQLErrors[0].message
			// message.error(ErrorMessageFormAPI(errorMessage))
		}
	}

	async sshEncrypt() {
		let localtoken = uuidv4();
		let keyssh = `-----BEGIN PUBLIC KEY-----
		MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqR9pG/J6RuWoo+W8XLBF
		s1H9dnhen8GYJO2tRsO1Rfn+t8lf8Yx7KK/ebMqocOR1VIfOhttdke9FDigtdl2C
		yz+mEJz/uOyPUi8JhKCT4/gHJOyVKgwkIExHC/Lke0W7t7O9pr/jz22VMcGx9qiY
		FTdnJLmxj127bJhI3EPNE0nYMAFY/UNytGSuLjMGPJJ+9vTLMRyfvXCg4owBy2ru
		A7S6/jxfBC5q/19c1ZG3Bedcg5N+5aD3VqtFJ8T2Q6uHJrZPwl4Asop7CtsE54x3
		xzqbaCC5EGQ29+X4LTlysOe8m3MUBhiBr1eyz1vWYrcsrGlGzfMq6EXPYsMMC6AE
		5wIDAQAB
		-----END PUBLIC KEY-----`.replace(/\n\s+/g, "\n")
		// if (localStorage.getItem('localtoken') == null) {
			localStorage.setItem('localtoken', localtoken)
		// }
		const clientId = localStorage.getItem('localtoken');
		const createdAt = Date.now()
		const apiKey = atob(apiKeyNews())
		const hashSum = crypto.createHash("sha256").update(`${clientId}:${createdAt}:${apiKey}`).digest('hex')
		const BeforeloginSTR = JSON.stringify({ clientId: clientId, createdAt: createdAt, hashSum: hashSum });
		let crypto1 = await crypto.publicEncrypt(keyssh, Buffer.from(BeforeloginSTR)).toString("base64")
		// console.log('crypto1',crypto1)
		this.setState({
			csId: crypto1
		})


		// await this.checkCaptcha()
		////////ส่ง////////

		// console.log("crypto.publicEncrypt()", crypto1);
	}

	onSubmitCheck = async ({ username, captchaText, captchaUid, organization }) => {
		const { client } = this.props
		await this.setState({
			checkCaptcha: sessionStorage.setItem('reCaptchaCheck', ''),
			organization: getOrganization(),
		})

		const value = {}
		value.csId = this.state.csId
		value.empCode = username
		if (captchaText) {
			value.captchaText = captchaText
		}
		if (captchaUid) {
			value.captchaUid = captchaUid
		}
		value.organization = getOrganization()

		try {
			
			const DataFetchAPI = await axiosAPI.post(
			`
				${checkLinkURL()}SSOService/checkEmpLogin`,
				{
					username:  value.empCode
				},
			);

         console.log("DataFetchAPI.data.", DataFetchAPI.data)

			if(DataFetchAPI.data.isVerify == "success"){
            // localStorage.setItem('expiredDate', DataFetchAPI.data.data.expiredDate)
				const { data, errors } = await client.query({
					query: Queries.verifyEmpCodeLogin,
					variables: {
						// ...value,
						empCode: DataFetchAPI.data.data.empCode,
						csId : this.state.csId,
						organization : getOrganization(),
						workflow: 'SIGNIN'
					}
				})
	
				//////////////////////addmodalINTERNAL_SERVER_ERROR
				if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
					await this.setState({
						showModalErrors: true
					})
				}
	

				if (data.verifyEmpCodeLogin) {
					localStorage.setItem('lsid', data.verifyEmpCodeLogin.lsid)
					localStorage.setItem('organization', getOrganization())
					localStorage.setItem('username', username)
					
					this.setState({
						check: "success",
						username:  DataFetchAPI.data.data.ssoId,
						dataProfileSSO: DataFetchAPI.data.data,
                  showFooter: false
					})
				}else {
					if (errors[0].extensions.code === 'AUTH_USER_OR_ORG_WITH_CAPTCHA_INVALID') {
						sessionStorage.setItem('showCaptchaStorage',true)
						this.setState({
							showCaptcha: true
						})
					}
				}
			}
			else if(DataFetchAPI.data.isVerify == "verify"){
				this.setState({
					check: "verify",
					username:  DataFetchAPI.data.data.ssoId,
					dataProfileSSO: DataFetchAPI.data.data,
               showModalErrorNameEng: false
				})
			}
			else if(DataFetchAPI.data.isVerify == "error"){
				message.error(DataFetchAPI.data.message)
			}
			else if(DataFetchAPI.data.isVerify == "checkusername"){
				this.setState({
					showTextModal: "กรุณากรอกชื่อผู้ใช้งานด้วยกาชาดไอดี (ตัวอย่างกาชาดไอดี name.surename)<br>หากต้องการตรวจสอบกาชาดไอดีคลิก",
               btnTextModal: "ตรวจสอบกาชาดไอดี",
					username:  DataFetchAPI.data.data.ssoId,
					dataProfileSSO: DataFetchAPI.data.data,
					visibleCheckusername: true,
               showModalErrorNameEng: false
				})
			}else if(DataFetchAPI.data.isVerify == "checkinvalidpassword"){
            this.setState({
					showTextModal: 'กรอกรหัสผ่านผิดครบ 5 ครั้งกรุณาทำการยืนยันตัวตนอีกครั้ง<br>เพื่อปลดล็อกบัญชีสำหรับเข้าใช้งาน',
               btnTextModal: "ยืนยันตัวตน",
					username:  DataFetchAPI.data.data.ssoId,
					dataProfileSSO: DataFetchAPI.data.data,
					visibleCheckusername: true,
               showModalErrorNameEng: false
				})
         }else if(DataFetchAPI.data.isVerify == "errorNameEng"){
            this.setState({
					showTextModal: DataFetchAPI.data.message.replace(/\n/g, "<br>"),
               btnTextModal: "ยืนยัน",
					// username:  DataFetchAPI.data.data.ssoId,
					// dataProfileSSO: DataFetchAPI.data.data,
					visibleCheckusername: true,
               showModalErrorNameEng: true
				})
         }

		} catch (error) {
			console.log("DataFetchAPI : error :", error)
		}
	}

	backlogin = async () => {
		sessionStorage.clear()
		localStorage.clear()
		this.sshEncrypt()
		await this.setState({
			check: false,
			showCaptcha: false,
         check:"login",
         showFooter: true
		})
	}

	checkCaptcha = async () => {
		const { client } = this.props
		const csId = this.state.csId
		const { data, errors } = await client.query({
			query: Queries.checkRequestCaptcha,
			variables: {
				csId: csId
			}
		})

		console.log(data.checkRequestCaptcha)

		if (data.checkRequestCaptcha === 1) {
			this.setState({
				showCaptcha: true
			})
		}
	}

	handleOkVersion = async () => {
		localStorage.setItem('showModalVersion', false)
		await this.setState({
			showModalVersion: false,
		});
	};

	handleCancelVersion = () => {
		localStorage.setItem('showModalVersion', false)
		this.setState({ showModalVersion: false });
	};

	handleCancelModalRead = () =>{
		this.setState({
			modalRead: false
		})
	}

	showModalRead = () =>{
		this.setState({
			modalRead: true
		})
	}

	showModalLine = () =>{
		this.setState({
			modalLine: true
		})
	}

	closeModalLine = () =>{
		this.setState({
			modalLine: false
		})
	}

	onClickQrcode = () =>{
		navigator.clipboard.writeText('https://line.me/R/ti/p/%40198wkvvu')
		message.success('ทำการคัดลอกลิงก์เรียบร้อย')
	}

	onSwitchMainPage = () =>{
		this.setState({
			check:"login",
			checkVerifyPassword: "true",
         showFooter: true
			// username: ,
		})
	}

	hideViewPageVerify = ()=>{
		this.setState({
			visibleCheckusername: false
		})
	}

	changeToViewPageVerify = () => {
      if(this.state.showModalErrorNameEng){
         this.setState({
            visibleCheckusername: false,
            showFooter: true
         })
      }else{
         this.setState({
            check:"verify",
            visibleCheckusername: false,
            showFooter: true
            // username: ,
         })
      }		
	}
   
   changeShowFooter = (check) =>{
      this.setState({
         showFooter: check
      })
   }

	async componentDidMount() {
      clearAllStorage()
		if(sessionStorage.getItem('showCaptchaStorage')){
			await this.setState({
				showCaptcha: true
			})
		}
		this.sshEncrypt()
	}

	render() {
		if (isLoggedIn()) {
         if( getIsTrial() !== "true"){
            return <Redirect to="/course" />
         }else{
            return <Redirect to="/news" />
         }
		}
		const { checkCaptcha, valueRecaptCha, showCaptcha, organization, showModalCheck, showModalVersion, modalRead, modalLine, loadingFullPage, btnTextModal, showTextModal } = this.state
		// console.log('checkCaptcha',checkCaptcha)
		return (
			<>
				<div style={{
					// height: "100vh",
					// backgroundImage: `url(${require("../../../assets/images/BGLogin.jpg")})`,
					backgroundPosition: 'center',
					// backgroundSize: 'cover',
					// backgroundRepeat: 'no-repeat'
				}}>
               <Spin spinning={loadingFullPage}>
                  <BackgroundDiv>
                     <Row >
                        <Col>
                           <FormDiv className="p-5-moblie mt-5 formDiv">
                                 {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                                 {
                                    this.state.showModalErrors &&
                                    <ModalErrors />
                                 }
                                 <Modal
                                    title=""
                                    visible={this.state.visibleCheckusername}
                                    width="700px"
                                    // visible={true}
                                    onCancel={
                                       (e) => this.hideViewPageVerify()
                                    }
                                    footer={[
                                                      
                                    ]}
                                 >
                                    <div align="center">
                                       <p
                                          style={{ lineHeight: "1"}} 
                                          dangerouslySetInnerHTML={{ __html: showTextModal }}
                                       >
                                       </p>
                                    </div>
                                    <div align="center" className="mt-4">
                                       <Button 
                                          className='mr-md-1' 
                                          type="primary btn-color-transparent btn-custom btn-cutom-width mb-2" 
                                          htmlType="submit" 
                                          onClick={this.changeToViewPageVerify} 
                                       >
                                          {/* ตรวจสอบกาชาดไอดี */}
                                          { btnTextModal }
                                       </Button>
                                    </div>
                                    
                                 </Modal>
                        
                                 <Modal
                                    title="แจ้งปัญหาในการใช้งาน"
                                       visible={modalLine}
                                       // onOk={this.handleOk}
                                       onCancel={this.closeModalLine}
                                       footer={[
                                                            
                                       ]}
                                    >
                                       <div className="mb-4">
                                          <Input 
                                             addonAfter={<span style={{ cursor:"pointer", color:"#00bcd4" }} 
                                             onClick={() => this.onClickQrcode()}>คัดลอก</span>} 
                                             defaultValue="https://line.me/R/ti/p/%40198wkvvu" 
                                             className="btn-copy"
                                             disabled={true}
                                          />
                                       </div>
                                       <div align="center">
                                          <img src={iconsQrcode} style={{ maxWidth: '100%', height: 'auto' }} />
                                       </div>
                                 </Modal>
                                 {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                                 {
                                 this.state.check == "login" &&
                                       <>
                                          <BeforeLoginForm 
                                          autoFocus 
                                          afterSubmit={this.onSubmitCheck} 
                                          checkCaptcha={checkCaptcha} 
                                          showCaptcha={showCaptcha} 
                                          checkVerifyPassword={this.state.checkVerifyPassword}
                                          username={this.state.username}
                                       />
                                          
                                       </>
                                 }
                                 {
                                    this.state.check == "success" &&
                                    <>
                                       <LoginForm 
                                          autoFocus 
                                          username={this.state.username} 
                                          afterSubmit={this.onSubmit} 
                                          backlogin={this.backlogin} 
                                          organization={getOrganization()} 
                                          changeToViewPageVerify={this.changeToViewPageVerify}
                                       />
                                    </>
                                 }
                                 {
                                    this.state.check == "verify" &&
                                    <ForgetPassword 
                                       dataProfileSSO={this.state.dataProfileSSO}
                                       onSwitchMainPage={this.onSwitchMainPage}
                                       changeShowFooter={this.changeShowFooter}
                                    />
                                 }

                                 {
                                    this.state.showFooter &&
                                    <Row type="flex" justify="center">
                                       <Col span={18} xs={24}>
                                          <div className=" pt-2">
                                             <Modal
                                                title="ข้อกำหนดและเงื่อนไข"
                                                visible={modalRead}
                                                onCancel={this.handleCancelModalRead}
                                                footer={[
                                                
                                                ]}
                                                width="600px"
                                             >
                                                <p>
                                                   * รหัสบุคลากร ให้อ้างอิงจากบัตรประจำตัวบุคลากร และ/หรือ บัตรเจ้าหน้าที่บำนาญ ที่ออกโดยสำนักงานบริหารทรัพยากรบุคคล (สบค.) 
                                                   หากมีข้อขัดข้องในการใช้รหัสบุคลากรเข้าระบบ สามารถติดต่อได้ที่งานฐานข้อมูลบุคลากร 0 2256 4058
                                                </p><br></br>
                                                <p>
                                                   ** สำหรับบุคลากรทางการแพทย์ และบุคลากรโรงพยาบาลจุฬาลงกรณ์ ให้อ้างอิงรหัสบุคลากรจากหน้าบัตรประจำตัวบุคลากร (บัตรเดบิตร่วมฯ ธนาคารกสิกรไทย) หากมีข้อขัดข้องในการใช้รหัสบุคลากรเข้าระบบ สามารถติดต่อได้ที่ Call Center ของ HR โรงพยาบาลจุฬาลงกรณ์ <br></br>0 2256 4000 ต่อ 4747
                                                </p><br></br>
                                                <p>
                                                   *** สำหรับบุคลากรโรงพยาบาลสมเด็จพระบรมราชเทวี ณ ศรีราชา  ให้อ้างอิงรหัสบุคลากรจากหน้าบัตรประจำตัวบุคลากร (บัตรเดบิตร่วมฯ ธนาคารกสิกรไทย) หากมีข้อขัดข้องในการใช้รหัสบุคลากรเข้าระบบ สามารถติดต่อได้ที่งานบริหารงานบุคคลและทะเบียนประวัติ ฝ่ายทรัพยากรบุคคล <br></br>0 38320 200 ต่อ 23417 และ 23419
                                                </p><br></br>
                                                <p>
                                                   **** สำหรับบุคลากรศูนย์บริการโลหิตแห่งชาติ ให้อ้างอิงรหัสบุคลากรจากหน้าบัตรประจำตัวบุคลากร (บัตรเดบิตร่วมฯ ธนาคารกสิกรไทย) หากมีข้อขัดข้องในการใช้รหัสบุคลากรเข้าระบบ สามารถติดต่อได้ที่ฝ่ายทรัพยากรบุคคล  0 2263 9600 - 99 ต่อ 1813
                                                </p><br></br>
                                             </Modal>
                                             <table>
                                             <tr onClick={(e) => this.showModalRead()} style={{ cursor:"pointer" }}>
                                                   <td style={{ verticalAlign:"top" }} className="pt-1" colSpan="2">
                                                      <p className="mb-2">
                                                         หากมีข้อสงสัย/แจ้งปัญหาการใช้ ติดต่อได้ที่
                                                      </p>
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td style={{ verticalAlign:"top" }}>
                                                      <div>
                                                         <img src={iconsLine} style={{ maxWidth: '24px', height: 'auto' }} />
                                                      </div>
                                                   </td>
                                                   <td style={{ verticalAlign:"top" }} className="pl-3">
                                                      <p className="mb-1 pt-1" style={{ cursor:"pointer" }} onClick={() => this.showModalLine()}>
                                                         {/* แจ้งปัญหาในการใช้งาน */}
                                                         <span style={{ fontSize:"20px", lineHeight:"0" }}>@</span>VTRC
                                                      </p>
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td style={{ verticalAlign:"top" }}>
                                                      <div className="ml-1">
                                                         <Icon type="phone" rotate={90} />
                                                      </div>
                                                   </td>
                                                   <td style={{ verticalAlign:"top" }} className="pl-3">
                                                   <a style={{ color:"#595959" }} href="mailto:callcenter@vtrcsupport.com">callcenter@vtrcsupport.com</a>
                                                   </td>
                                                </tr>
                                                <tr onClick={(e) => this.showModalRead()} style={{ cursor:"pointer" }}>
                                                   <td style={{ verticalAlign:"top"}}>
                                                      <div style={{ paddingLeft:"3px" }}>
                                                         <svg style={{ display:"inline-block" }} height="30px" viewBox="-21 -47 682.66669 682" width="18px" xmlns="http://www.w3.org/2000/svg"><path d="m552.011719-1.332031h-464.023438c-48.515625 0-87.988281 39.464843-87.988281 87.988281v283.972656c0 48.414063 39.300781 87.816406 87.675781 87.988282v128.863281l185.191407-128.863281h279.144531c48.515625 0 87.988281-39.472657 87.988281-87.988282v-283.972656c0-48.523438-39.472656-87.988281-87.988281-87.988281zm50.488281 371.960937c0 27.835938-22.648438 50.488282-50.488281 50.488282h-290.910157l-135.925781 94.585937v-94.585937h-37.1875c-27.839843 0-50.488281-22.652344-50.488281-50.488282v-283.972656c0-27.84375 22.648438-50.488281 50.488281-50.488281h464.023438c27.839843 0 50.488281 22.644531 50.488281 50.488281zm0 0"/><path d="m171.292969 131.171875h297.414062v37.5h-297.414062zm0 0"/><path d="m171.292969 211.171875h297.414062v37.5h-297.414062zm0 0"/><path d="m171.292969 291.171875h297.414062v37.5h-297.414062zm0 0"/></svg>
                                                      </div>
                                                   </td>
                                                   <td style={{ verticalAlign:"top" }} className="pl-3 pt-1">
                                                      ข้อกำหนดและเงื่อนไข
                                                   </td>
                                                </tr>
                                             </table>
                                          </div>
                                       </Col>
                                    </Row>
                                 }
                                 
                           </FormDiv>
                        </Col>
                        <Col className="mt-4">
                           <FooterLogin></FooterLogin>
                        </Col>
                     </Row>
                     
                  </BackgroundDiv>
               </Spin>
				</div>
				
			</>
		)
	}
}

export default withApollo(Login)
